<app-input
  [control]="control"
  [label]="label"
  [secondaryLabel]="secondaryLabel"
  [placeholder]="placeholder"
  [id]="id"
  [errorMessage]="errorMessage"
  [inputClass]="inputClass"
  [labelClass]="labelClass"
  [amount]="true"
  [showPrefix]="true"
>
  <span prefix class="text-grey-500">₦</span>
</app-input>
